import { SagaIterator } from 'redux-saga';
import firebase from 'firebase/app';
import { all, takeLatest, select, call, put } from 'redux-saga/effects';
import _ from 'lodash';
import {
  GET_NOTIFICATIONS,
  NotificationProps,
  SendNotification,
  SEND_NOTIFICATION,
  UPDATE_UNREAD_COUNT,
  UPDATE_READ_NOTIFICATION,
  UpdateReadNotification,
} from './types';
import { getUserState } from '../user/selector';
import { MCAFirebaseSaga } from '../root-saga';
import { FirestoreSnapshot } from '../meals/types';
import { setNotifications } from './actions';
import { setError } from '../app-globals/actions';
import { getOrders } from '../orders/actions';

function* fetchNotifications() {
  try {
    const { user } = yield select(getUserState);
    const notificationSnapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      `notification/${user.userid}/notification`
    );
    const notificationData: NotificationProps[] = [];
    notificationSnapshot.forEach((item: FirestoreSnapshot) => {
      notificationData.push({ id: item.id, ...item.data() });
    });
    const sortedNotification = _.orderBy(
      notificationData,
      ['timeadded'],
      'desc'
    );

    const unreadData = yield call(
      MCAFirebaseSaga.firestore.getDocument,
      `notification/${user.userid}`
    );
    const unreadNotifcation = unreadData.exists ? unreadData.data().unread : 0;
    yield put(getOrders());
    yield put(setNotifications(sortedNotification, unreadNotifcation));
  } catch (e) {
    console.log(e);
  }
}

function* sendNotification({ send, receiver }: SendNotification) {
  try {
    const { user } = yield select(getUserState);
    const firestoreAddDocument = MCAFirebaseSaga.firestore.addDocument;
    const firestoreSetDocument = MCAFirebaseSaga.firestore.setDocument;
    const body = {
      timeadded: new Date(),
      senderId: user.userid,
      read: false,
      ...send,
    };

    yield call(
      firestoreSetDocument,
      `/notification/${receiver}`,
      {
        unread: firebase.firestore.FieldValue.increment(1),
      },
      { merge: true }
    );
    const addNotification = yield call(
      firestoreAddDocument,
      `notification/${receiver}/notification`,
      body
    );
    if (send.action === 'deleted') {
      yield call(
        MCAFirebaseSaga.functions.call,
        'mealDeletions',
        {
          meal: send.mealname,
          reason: send.reason,
          cook: receiver,
        },
        { method: 'POST' }
      );
    }

    console.log(addNotification);
  } catch (e) {
    console.log(e);
    yield put(setError(true, e));
  }
}

function* updateUnreadCount() {
  const { user } = yield select(getUserState);
  const firestoreSetDocument = MCAFirebaseSaga.firestore.setDocument;
  yield call(
    firestoreSetDocument,
    `/notification/${user.userid}/`,
    {
      unread: 0,
    },
    { merge: true }
  );
}

function* updateReadNotification({ id }: UpdateReadNotification) {
  const { user } = yield select(getUserState);
  const firestoreSetDocument = MCAFirebaseSaga.firestore.setDocument;
  yield call(
    firestoreSetDocument,
    `notification/${user.userid}/notification/${id}`,
    { read: true },
    { merge: true }
  );
}

export function* NotificationSaga(): SagaIterator<void> {
  yield all([
    takeLatest(GET_NOTIFICATIONS, fetchNotifications),
    takeLatest(SEND_NOTIFICATION, sendNotification),
    takeLatest(UPDATE_UNREAD_COUNT, updateUnreadCount),
    takeLatest(UPDATE_READ_NOTIFICATION, updateReadNotification),
  ]);
}
